import http from "../../http-common";
/* eslint-disable */
class KapusdokkesService {
  kapusdokkesList(page, itemPerPage, keyword) {
    return http.get(
      "/kapusdokkes/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);

    if (data.periode_dari)
      bodyFormData.append("periode_dari", data.periode_dari);

    if (data.periode_ke) bodyFormData.append("periode_ke", data.periode_ke);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/kapusdokkes", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("nama", data.nama);
    if (data.periode_dari)
      bodyFormData.append("periode_dari", data.periode_dari);

    if (data.periode_ke) bodyFormData.append("periode_ke", data.periode_ke);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.put(`/kapusdokkes/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/kapusdokkes/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new KapusdokkesService();
